const chimeraURL = process.env.VUE_APP_CHIMERA_URL;
const dexGraphqlURL = process.env.VUE_APP_DEX_GRAPHQL_URL;
const stellateGraphqlURL = process.env.VUE_APP_STELLATE_API_URL;
const dexAuthenticationURL = process.env.VUE_APP_DEX_AUTHENTICATION_URL;
const descomplicaAuthenticationURL = process.env.VUE_APP_DESCOMPLICA_AUTHENTICATION_URL;
const passepartoutURL = process.env.VUE_APP_PASSEPARTOUT_URL;
const forumURL = process.env.VUE_APP_WESTEROS_UNDERGRADFORUM_URL;
const pearsonURL = process.env.VUE_APP_PEARSON_URL;
const lyceumAuthenticationUrl = process.env.VUE_APP_LYCEUM_AUTHENTICATION_URL;
const pegasusEponaEndpointUrl = process.env.VUE_APP_PEGASUS_EPONA_ENDPOINT_URL;
const pegasusPepeLegalEndpointUrl = process.env.VUE_APP_PEGASUS_PEPE_LEGAL_ENDPOINT_URL;
const selectiveProcessUrl = process.env.VUE_APP_SELECTIVE_PROCESS_URL;
const microcertificateUrl = process.env.VUE_APP_MICROCERTIFICATE_URL;
const pegasusSilverEndpointUrl = process.env.VUE_APP_PEGASUS_SILVER_URL;

const westerosGraphqlURL = {
  CROW_ENDPOINT: process.env.VUE_APP_WESTEROS_CROW_GRAPHQL,
  CROW_WS_ENDPOINT: process.env.VUE_APP_WESTEROS_CROW_GRAPHQL_WS,
  REACTION_ENDPOINT: process.env.VUE_APP_WESTEROS_REACTIONS_GRAPHQL,
  PROFILE_ENDPOINT: process.env.VUE_APP_WESTEROS_PROFILE_GRAPHQL,
  ENROLLMENTS_ENDPOINT: process.env.VUE_APP_WESTEROS_ENROLLMENTS_GRAPHQL,
  STUDENTNOTES_ENDPOINT: process.env.VUE_APP_WESTEROS_STUDENTNOTES_GRAPHQL,
  KINGSLANDING_ENDPOINT: process.env.VUE_APP_WESTEROS_KINGSLANDING_GRAPHQL,
  MAMATA_ENDPOINT: process.env.VUE_APP_WESTEROS_MAMATA_GRAPHQL,
};

const ticketsURL = process.env.VUE_APP_TICKETS_URL;
const fileUploadURL = process.env.VUE_APP_FILE_UPLOAD_URL;
const lapURL = process.env.VUE_APP_LAP_URL;
const postBackofficeAdminURL = process.env.VUE_APP_POST_BACKOFFICE_ADMIN_URL;
const alumniURL = process.env.VUE_APP_ALUMNI_URL;
const termsOfUseURL = process.env.VUE_APP_USE_TERMS_OF_USE_ENDPOINT_URL;
const appGatherTownUrl = process.env.VUE_APP_GATHER_TOWN_URL;
const baseUrlWithoutUndergrad = process.env.BASE_URL?.replace(/\/graduacao/, '');
const linkedInCallbackUri = process.env.VUE_APP_LINKEDIN_REDIRECT_URI || '';
const linkedInAuthEndpoint = process.env.VUE_APP_LINKEDIN_AUTH_ENDPOINT || '';
const descomplicaBasePath = process.env.VUE_APP_DESCOMPLICA_BASE_PATH;
const flowpress = process.env.VUE_APP_FLOWPRESS_PATH || '';

const appDownloadRedirectUrl = process.env.VUE_APP_APP_STORE_REDIRECT_URL || '';
const lyceumDocumentsUrl = process.env.VUE_APP_LYCEUM_DOCUMENTS_URL || '';

const botmakerUrl = process.env.VUE_APP_BOTMAKER_URL || '';

export const ENDPOINTS = {
  chimera: chimeraURL,
  dexGraphql: dexGraphqlURL,
  stellate: stellateGraphqlURL,
  dexAuthentication: dexAuthenticationURL,
  descomplicaAuthentication: descomplicaAuthenticationURL,
  passepartout: passepartoutURL,
  forum: forumURL,
  pearson: pearsonURL,
  lyceumAuthentication: lyceumAuthenticationUrl,
  westerosGraphql: westerosGraphqlURL,
  fileUpload: fileUploadURL,
  lap: lapURL,
  postBackofficeAdmin: postBackofficeAdminURL,
  alumni: alumniURL,
  termsOfUse: termsOfUseURL,
  appGatherTown: appGatherTownUrl,
  epona: pegasusEponaEndpointUrl,
  pegasusPepeLegal: pegasusPepeLegalEndpointUrl,
  selectiveProcess: selectiveProcessUrl,
  microcertificate: microcertificateUrl,
  pegasusSilver: pegasusSilverEndpointUrl,
  baseUrlWithoutUndergrad,
  linkedInCallbackUri,
  linkedInAuthEndpoint,
  descomplicaBasePath,
  flowpress,
  appDownloadRedirectUrl,
  lyceumDocumentsUrl,
  botmakerUrl,
  ticketsURL,
};
